import styles from "./styles/vertical-select-voice-input.module.scss";
import React from "react";
import { ModalType } from "@/providers/modal-provider/modal-context.types";
import SelectVoiceInputBase from "@/components/common/voice-selector/inputs/select-voice-input-base";

interface SelectVoiceInputProps {
  isEmptyVoiceFocused?: boolean;
  modalType: ModalType;
  isDisabled?: boolean;
}

const VerticalSelectVoiceInput = ({
  isEmptyVoiceFocused,
  modalType,
  isDisabled,
}: SelectVoiceInputProps) => {
  return (
    <SelectVoiceInputBase
      modalType={modalType}
      isDisabled={isDisabled}
      isEmptyVoiceFocused={isEmptyVoiceFocused}
      overriddenWrapperStyle={styles.wrapper}
    />
  );
};

export default VerticalSelectVoiceInput;
